var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 51,
    viewBox: "0 0 48 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7707 0.449219C10.6484 0.449219 0 11.7558 0 25.6887C0 39.6216 10.6484 50.9079 23.7707 50.9079C36.8929 50.9079 47.5515 39.6115 47.5515 25.6887C47.5515 11.7659 36.9031 0.449219 23.7707 0.449219ZM28.9829 31.2152L9.50827 40.8283L18.5686 20.1723L38.0433 10.5491L28.9829 31.2254V31.2152Z",
    fill: "url(#paint0_linear_187_21413)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_187_21413",
    x1: 2414.19,
    y1: 206.321,
    x2: 47.5633,
    y2: 2015.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4FEAD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.f03139a4bac9e7011998448637339b85.svg";
export { ForwardRef as ReactComponent };